import { render, staticRenderFns } from "./vip-dialog.vue?vue&type=template&id=cfb6835c&scoped=true&"
import script from "./vip-dialog.vue?vue&type=script&lang=js&"
export * from "./vip-dialog.vue?vue&type=script&lang=js&"
import style0 from "./vip-dialog.vue?vue&type=style&index=0&id=cfb6835c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb6835c",
  null
  
)

export default component.exports